// extracted by mini-css-extract-plugin
export default {"container":"EmailRecipients_container__CZCaN","to":"EmailRecipients_to__hYyST","recipient":"EmailRecipients_recipient__qWMW7","email":"EmailRecipients_email__49YXT"};